
<ul class="nav nav-border-top bg-white" style="border-top: 1px solid #f3f3f3;">
  @for (tab of tabs; track tab) {
    @if (!tab.tabTitleHidden) {
      <li class="nav-item clickable mt-2 mb-2" (click)="selectTab(tab)" >
        <a class="nav-link" [class.active]="tab.selected">{{tab.tabTitle | translate}}</a>
      </li>
    }
  }
</ul>

<ng-content></ng-content>
